import * as S from "./HealthEnterInfoItem.style";
import { ReactComponent as IconAlert } from "@/styles/assets/svg/icon_alert_large.svg";

export const HealthEnterWarningItem = () => {
  return (
    <S.HealthEnterWarningItem>
      <S.ItemHeader>
        <IconAlert width={14} height={18} />
        개인 맞춤형 운동 프로그램 추천을 위해 건강 정보값을 입력해 주세요.{" "}
        <br />
        *건강 정보값을 입력 하지 않아도 [운동하기]는 가능합니다.
      </S.ItemHeader>
    </S.HealthEnterWarningItem>
  );
};
